module.exports = __webpack_public_path__ + "static/media/00_strawberry_robot_card.f3504fc3.png";